<template>
  <div
    class="copied-hashtags"
    :class="{ 'is-visible': isVisible}"
  >
    <h3>hashtags copiadas com sucesso!</h3>
  </div>
</template>

<script>
export default {
  data: () => ({
    isVisible: false,
    timer: null,
  }),

  watch: {
    isVisible (isVisible) {
      if (isVisible) {
        this.timer = setTimeout(() => this.isVisible = false, 4000)
      } else {
        clearTimeout(this.timer)
      }
    }
  },

  methods: {
    show () {
      this.isVisible = true
    },

    hide () {
      this.isVisible = false
    }
  }
}
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .copied-hashtags {
    z-index: 100;
    position: fixed;
    bottom: 0;
    width: 100%;
    background: $purple400;
    color: #FFFFFF;
    transform: translateY(100%);
    transition: .5s transform;

    &.is-visible { 
      transform: translateY(0); 
    }

    h3 {
      font-size: 22px;
      text-align: center;
      padding-top: 30px;
      padding-bottom: 30px;
    }
  }
</style>